import React from 'react';
import { Modal, Button, Icon, Message } from 'semantic-ui-react';

const DECOMMISSION_ACTION_WARNING =
    'You are about to proceed with a tenant decommission action. This operation will result in service termination and associated resource cleanup. Once executed, this action cannot be undone.';

const DecommissionActionWarningModal = ({
    open,
    onBack,
    onConfirm,
    loading = false,
    confirmLabel = 'Confirm & Proceed',
    validityBlock = null
}) => {
    const isValidityBlocked = !!validityBlock?.blocked;
    const warningMessage = isValidityBlocked
        ? (validityBlock.message || DECOMMISSION_ACTION_WARNING)
        : DECOMMISSION_ACTION_WARNING;

    return (
        <Modal
            open={open}
            onClose={loading ? undefined : onBack}
            size="small"
            closeOnDimmerClick={!loading}
            closeOnEscape={!loading}
        >
            <Modal.Header style={{
                backgroundColor: isValidityBlocked ? '#FFF5F5' : '#FFFAF0',
                color: isValidityBlocked ? '#9B2C2C' : '#9A6B00'
            }}>
                <Icon
                    name="warning sign"
                    color={isValidityBlocked ? 'red' : 'orange'}
                />
                {isValidityBlocked
                    ? 'Validity Period Changed — Cannot Proceed'
                    : 'Tenant Decommission Warning'}
            </Modal.Header>
            <Modal.Content>
                <Message warning={!isValidityBlocked} negative={isValidityBlocked}>
                    <p style={{ marginBottom: 0, whiteSpace: 'pre-wrap' }}>{warningMessage}</p>
                </Message>
            </Modal.Content>
            <Modal.Actions>
                <Button
                    onClick={onBack}
                    loading={loading && isValidityBlocked}
                    disabled={loading}
                    negative={isValidityBlocked}
                >
                    {isValidityBlocked ? 'Close' : 'Go Back'}
                </Button>
                {!isValidityBlocked && (
                    <Button primary onClick={onConfirm} loading={loading} disabled={loading}>
                        {confirmLabel}
                    </Button>
                )}
            </Modal.Actions>
        </Modal>
    );
};

export default DecommissionActionWarningModal;
